// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__fClxP","label":"Tag_label__dJQy4"};